import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import ComboBox from './ComboBox';
import SelectControl from './SelectControl';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import startCase from 'lodash/startCase';
import { snakeCase } from '../helpers';

const styles = theme => ({
    textField: {
        margin: `${theme.spacing.unit/2}px 0`,
    },
});


const asFormControl = (form, requiredFields=[], toSnakeCase=true) => {
    class FormComponent extends Component {
        state = {
            openTooltip: false,
            maskInputValue: '',
        };

        componentDidUpdate(prevProps, prevState) {
            if (this.props.showErrors && !prevProps.showErrors && !this.state.openTooltip) {
                this.setState({openTooltip: true});
            }
        }

        getValueFromMask = (mask, value) => {
            let newValue = '';
            let valueIndex = 0;
            forEach(mask, (maskVal, i) => {
                const char = value.charAt(valueIndex);
                if (maskVal instanceof RegExp) {
                    if (valueIndex === value.length) {
                        return false;
                    }
                    const char = value.charAt(valueIndex);
                    if (maskVal.test(char)) {
                        newValue += char;
                        valueIndex++;
                    } else {
                        return false;
                    }
                } else if (maskVal === char) {
                    valueIndex++;
                }
            });
            return newValue;
        };

        getMaskDisplayValue = (mask, value) => {
            let newValue = '';
            let maskValueHold = '';
            const { maskInputValue } = this.state;
            let valueIndex = 0;
            forEach(mask, (maskVal, i) => {
                if (valueIndex === value.length) {
                    if (maskVal instanceof RegExp) {
                        return false;
                    } else {
                        const char = maskInputValue.charAt(Math.min(i, maskInputValue.length - 1));
                        maskValueHold += maskVal;
                        if (char === maskVal) {
                            newValue += maskValueHold;
                            maskValueHold = '';
                        }
                    }
                } else {
                    if (maskVal instanceof RegExp) {
                        const char = value.charAt(valueIndex);
                        if (maskVal.test(char)) {
                            newValue += char;
                            valueIndex++;
                        } else {
                            return false;
                        }
                    } else {
                        newValue += maskVal;
                    }
                }
            });
            return newValue;
        };

        handleMaskedInputChange = (name) => (e) => {
            const { mask } = this.props;
            this.setState({maskInputValue: e.target.value}, () => {
                const value = this.getValueFromMask(mask, this.state.maskInputValue);
                form.updateFormData(name)(e, value);
            });
        };

        handleTooltipOpen = e => {
            this.setState({openTooltip: true});
        };

        handleTooltipClose= e => {
            this.setState({openTooltip: false});
        };
        
        getInputProps = InputProps => {
            const { inputProps, ...other } = InputProps;
            return other; 
        }

        render() {
            const { classes, className='', component, mask, readOnly, type = 'text', name, 
            inputProps={}, InputProps={}, placeholderLabel=false, showErrors, ...other } = this.props;
            const inputName = toSnakeCase ? snakeCase(name) : name;
            const { formData, formErrors } = form.state;
            const value = get(formData, inputName, '');
            const defaultProps = {
                onChange: readOnly ? undefined : (mask ? this.handleMaskedInputChange(inputName) : form.updateFormData(inputName)),
                label: placeholderLabel ? undefined : startCase(name),
                value,
            };
            const error = get(formErrors, inputName);
            let Component = component;
            let componentProps = {};
            let hiddenInput = null;
            if (!component) {
                componentProps = {
                    fullWidth: true,
                    variant: "outlined",
                    className: `${className} ${classes.textField}`,
                    InputLabelProps: {
                        shrink: true,
                    },
                    error: !!error,
                    inputProps: {
                        name: inputName,
                        readOnly: readOnly,
                        placeholder: placeholderLabel ? startCase(name) : undefined,
                        required: inputProps.required || requiredFields.indexOf(inputName) > 0,
                        ...inputProps,
                        ...InputProps.inputProps,
                    },
                }
                switch (type) {
                    case 'comboBox':
                        Component = ComboBox;
                        componentProps.label = other.label || defaultProps.label;
                        const textFieldProps = get(other, 'textFieldProps', {});
                        componentProps = {
                            textFieldProps: {...componentProps, ...textFieldProps},
                            InputProps: {
                                name: inputName,
                                ...InputProps
                            }
                        };
                        break;
                    case 'select':
                        componentProps.className = className;
                        Component = SelectControl;
                        break;
                    default:
                        componentProps.InputProps = this.getInputProps(InputProps);
                        if (mask) {
                            const { onBlur, placeholder, ...otherInputProps } = componentProps.inputProps;
                            hiddenInput = <input type='hidden' name={inputName} value={value} {...otherInputProps}/>;
                            defaultProps.value = this.getMaskDisplayValue(mask, value);
                            componentProps.inputProps = {
                                onBlur,
                                placeholder
                            };
                        }
                        Component = TextField;
                }
            }
            const renderedComponent = (
                <div>
                    <Component {...defaultProps} {...componentProps } {...other} onFocus={this.handleTooltipOpen}/>
                    {hiddenInput}
                </div>
            );
            if (error) {
                return (
                    <Tooltip placement='top' title={error} onClose={this.handleTooltipClose} open={this.state.openTooltip}>
                        {renderedComponent}
                    </Tooltip>
                );
            }
            return renderedComponent;
        }
    }

    FormComponent.propTypes = {
        classes: PropTypes.object.isRequired,
        name: PropTypes.string,
        type: PropTypes.string,
    };

    return withStyles(styles)(FormComponent);
};


export default asFormControl;
